module.exports = __webpack_public_path__ + "static/media/download_icn_dark.848bcbf8.png";